
const videoData = {
    '/fruitveg': {
      backgroundImage: '/choppies/assets/fruit_veg.jpg',
      backgroundColor: '#1a3300',
      tableWidth: '370px',
      videoProcesses: [
        { name: 'Process', video: '', pdf: '/choppies/assets/pdf/fruitveg/sop_user_guide.pdf', moduleName: 'fruit & veg' },
        { name: 'Start of the Day', video: '/choppies/assets/video/fruitveg/fruit_veg_startofday.mp4', moduleName: 'fruit & veg' },
        { name: 'Hygiene & Cleaning', video: '/choppies/assets/video/fruitveg/fruit_veg_hygiene.mp4', moduleName: 'fruit & veg' },
        { name: '\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0Inventory Management', video: '/choppies/assets/video/fruitveg/fruit_veg_inventory.mp4', moduleName: 'fruit & veg' },
        { name: 'Merchandising', video: '/choppies/assets/video/fruitveg/fruit_veg_merchandising.mp4', moduleName: 'fruit & veg' },
        { name: 'Customer Service', video: '/choppies/assets/video/fruitveg/fruit_veg_customerservice.mp4', moduleName: 'fruit & veg' }
      ]
    },
    '/cfc': {
      backgroundImage: '/choppies/assets/cfc_bg.jpg',
      backgroundColor: '#212121',
      tableWidth: '390px',
      videoProcesses: [
        { name: 'Process', video: '', pdf: '/choppies/assets/pdf/cfc/sop_user_guide.pdf', moduleName: 'cfc' },
        { name: 'Start of the Day', video: '/choppies/assets/video/cfc/cfc_process.mp4', moduleName: 'cfc' },
        { name: 'Hygiene & Cleaning', video: '/choppies/assets/video/cfc/cfc_hygiene.mp4', moduleName: 'cfc' },
        { name: 'Inventory Management', video: '/choppies/assets/video/cfc/cfc_inventory.mp4', moduleName: 'cfc' },
        { name: 'Production', video: '/choppies/assets/video/cfc/cfc_production.mp4', moduleName: 'cfc' },
        { name: 'Merchandising', video: '/choppies/assets/video/cfc/cfc_merchandising.mp4', moduleName: 'cfc' },
        { name: 'Customer Service', video: '/choppies/assets/video/cfc/cfc_customerservice.mp4', moduleName: 'cfc' }
      ]
    }, '/bakery': {
      backgroundImage: '/choppies/assets/bakery_bg.png',
      backgroundColor: '#683B12',
      tableWidth: '390px',
      videoProcesses: [
        { name: 'Process', video: '', pdf: '/choppies/assets/pdf/bakery/sop_user_guide.pdf', moduleName: 'bakery' },
        { name: 'Start of the Day', video: '/choppies/assets/video/bakery/bakery_process.mp4', moduleName: 'bakery' },
        { name: 'Hygiene & Cleaning', video: '/choppies/assets/video/bakery/bakery_hygiene.mp4', moduleName: 'bakery' },
        { name: 'Inventory Management', video: '/choppies/assets/video/bakery/bakery_inventory.mp4', moduleName: 'bakery' },
        { name: 'Production', video: '/choppies/assets/video/bakery/bakery_production.mp4', moduleName: 'bakery' },
        { name: 'Merchandising', video: '/choppies/assets/video/bakery/bakery_merchandising.mp4', moduleName: 'bakery' },
        { name: 'Customer Service', video: '/choppies/assets/video/bakery/bakery_customerservice.mp4', moduleName: 'bakery' }
      ]
    }, '/butchery': {
      backgroundImage: '/choppies/assets/butchery_bg.jpg',
      backgroundColor: '#5B2B2D',
      tableWidth: '390px',
      videoProcesses: [
        { name: 'Process', video: '', pdf: '/choppies/assets/pdf/butchery/sop_user_guide.pdf', moduleName: 'butchery' },
        { name: 'Start of the Day', video: '/choppies/assets/video/butchery/butchery_process.mp4', moduleName: 'butchery' },
        { name: 'Hygiene & Cleaning', video: '/choppies/assets/video/butchery/butchery_hygiene.mp4', moduleName: 'butchery' },
        { name: 'Inventory Management', video: '/choppies/assets/video/butchery/butchery_inventory.mp4', moduleName: 'butchery' },
        { name: 'Production', video: '/choppies/assets/video/butchery/butchery_production.mp4', moduleName: 'butchery' },
        { name: 'Merchandising', video: '/choppies/assets/video/butchery/butchery_merchandising.mp4', moduleName: 'butchery' },
        { name: 'Customer Service', video: '/choppies/assets/video/butchery/butchery_customerservice.mp4', moduleName: 'butchery' }
       
      ]
    }, '/takeaway': {
      backgroundImage: '/choppies/assets/takeaway_bg.jpg',
      backgroundColor: '#1A150A',
      tableWidth: '400px',
      videoProcesses: [
        { name: 'Process', video: '', pdf: '/choppies/assets/pdf/takeaway/sop_user_guide.pdf', moduleName: 'take away' },
        { name: 'Start of the Day', video: '/choppies/assets/video/takeaway/takeaway_process.mp4', moduleName: 'take away' },
        { name: 'Hygiene & Cleaning', video: '/choppies/assets/video/takeaway/takeaway_hygiene.mp4', moduleName: 'take away' },
        { name: 'Inventory Management', video: '/choppies/assets/video/takeaway/takeaway_inventory.mp4', moduleName: 'take away' },
        { name: 'Production', video: '/choppies/assets/video/takeaway/takeaway_production.mp4', moduleName: 'take away' },
        { name: 'Merchandising', video: '/choppies/assets/video/takeaway/takeaway_merchandising.mp4', moduleName: 'take away' },
        { name: 'Customer Service', video: '/choppies/assets/video/takeaway/takeaway_customerservice.mp4', moduleName: 'take away' }
      ]
    }, '/brmanager': {
      backgroundImage: '/choppies/assets/brmanager_bg.jpg',
      backgroundColor: '#212121',
      tableWidth: '250px',
      videoProcesses: [
        { name: 'Process', video: '', pdf: '/choppies/assets/pdf/brmanager/sop_user_guide.pdf', moduleName: 'br. manager' },
        { name: 'Start of the Day', video: '/choppies/assets/video/brmanager/brmanager_process.mp4', moduleName: 'br. manager' },
        { name: 'Floor Walk', video: '/choppies/assets/video/brmanager/brmanager_floorwalk.mp4', moduleName: 'br. manager' },
        { name: 'Receiving & Waste Management', video: '/choppies/assets/video/brmanager/brmanager_waste.mp4', moduleName: 'br. manager' },
        { name: 'Look & Feel', video: '/choppies/assets/video/brmanager/brmanager_lookfeel.mp4', moduleName: 'br. manager' },
        { name: 'Maintenance', video: '/choppies/assets/video/brmanager/brmanager_maintenance.mp4', moduleName: 'br. manager' },
        { name: 'S. H. E.', video: '/choppies/assets/video/brmanager/brmanager_she.mp4', moduleName: 'br. manager' }
      ]
  
    }
  };
  export default videoData;  